//formato data: "2001-06-07T09:55:00"
export const estrapolaData = (data) => {
    if (data === undefined || data === null)
        return ""
    else
        return data?.slice(8, 10) + "/" + data?.slice(5, 7) + "/" + data?.slice(0, 4);
}

export const estrapolaOra = (data) => {
    if (data === undefined || data === null)
        return ""
    else
        return data?.slice(11, 13) + ":" + data?.slice(14, 16);
}

export const generaLog = (message, level) => {
    if (process.env.REACT_APP_ENV_TYPE === 'sviluppo' || process.env.REACT_APP_ENV_TYPE === 'integrazione') {
        if (level === "log") {
            console.log(message);
        } else if (level === "error") {
            console.error(message);
        } else {
            console.log(message);
        }
    }
}
